export const GET_PRODUCTS = '[Products] Get Products';
export const GET_PRODUCTS_SUCCESS = '[Products] Get Products Success';
export const GET_PRODUCTS_ERROR = '[Products] Get Products Error';

export const GET_PRODUCTS_EXTRA_FEATURES =
  '[Products] Get Products Extra Features';
export const GET_PRODUCTS_SUCCESS_EXTRA_FEATURES =
  '[Products] Get Products Extra Features Success';
export const GET_PRODUCTS_ERROR_EXTRA_FEATURES =
  '[Products] Get Products Extra Features Error';

export const PRODUCT_SELECTED = '[Products] Product Selected';
